import db from 'mime-standard';

const validateEmail = email => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const validatePasword = password => {
  let result = false;
  const check1 = /(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*()\-_+=]{10,}/g;
  const check2 =
    /(?=.*[a-zA-Z])(?=.*[!@#$%^&*()\-_+=])[a-zA-Z0-9!@#$%^&*()\-_+=]{10,}/g;
  const check3 =
    /(?=.*[!@#$%^&*()\-_+=])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*()\-_+=]{10,}/g;
  if (check1.test(password)) {
    result = true;
  }
  if (check2.test(password)) {
    result = true;
  }
  if (check3.test(password)) {
    result = true;
  }
  return result;
};

const toISOFormattedDate = date => {
  let isodate = date.toISOString();
  return (isodate = isodate
    .replaceAll('-', '')
    .replaceAll('T', '')
    .replaceAll(':', '')
    .replaceAll('Z', '')
    .split('.')[0]);
};

const Database = {
  '3gpp': 'video/3gpp',
  mp3: 'audio/mpeg',
  x3db: 'model/x3d+fastinfoset',
  x3dv: 'model/x3d-vrml',
  wmv: 'video/x-ms-wmv',
};

for (const mime in db) {
  const extensions = db[mime];
  for (let i = 0, l = extensions.length; i < l; i++) {
    const extension = extensions[i];
    if (extension in Database) continue;
    Database[extension] = mime;
  }
}

const validateFileExtension = (file, extensions) => {
  const fileExtension = file.name.split('.').pop();
  const fileMime = file.type;

  // 파일 확장자와 형식 일치하는지
  if (Database[fileExtension] !== fileMime) return false;

  // 등록한 확장자 중에 있는지
  if (extensions.includes(fileExtension)) return true;

  // jpg, jpeg처럼 특수한 경우인지 확인
  for (const ext of extensions) {
    if (db[fileMime].includes(ext)) return true;
  }

  return false;
};

const isAllowExtension = (format, extension) => {
  return Database[extension]
    ? new RegExp(`^${format}/.*`).test(Database[extension])
    : false;
};

export {
  validateEmail,
  validatePasword,
  toISOFormattedDate,
  validateFileExtension,
  isAllowExtension,
};
